<template>
  <div>
    <listFilter
      :formItems="formItems"
      :filter="filter"
      @searchTableInfo="searchTableInfo"
      @resetTableInfo="resetTableInfo"
    />
    <div class="tableWrap">
      <Table
        border
        :columns="columns"
        size="small"
        stripe
        :data="dataSource"
        disabled-hover
        row-key="id"
        ref="tableRef"
      ></Table>
      <div style="margin: 10px; overflow: hidden">
        <div style="float: right">
          <Page
            show-total
            show-sizer
            :total="totalCount"
            :current="filter.pageIndex"
            :page-size="filter.pageSize"
            :page-size-opts="[10, 25, 50, 100]"
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
          />
        </div>
      </div>
    </div>
    <Modal title="转交" v-model="transferModalFlag" width="800px" transfer class="promoter_person" :mask-closable="false" @on-visible-change="handleVisible">
      <CopyerSetting ref="CopyerSetting" :dataConfig.sync="dataConfig" typeTitle="抄送人" :assignType="true" />
      <Form label-position="left" :label-width="100" :model="transferForm" ref="transferForm" :rules="transferValid">
        <FormItem label="转交原因:" prop="auditNote">
          <Input type="textarea" :rows="4" placeholder="最多输入200字" v-model="transferForm.auditNote" />
        </FormItem>
      </Form>
      <span slot="footer" class="dialog-footer">
        <Button @click="transferModalFlag = false">取 消</Button>
        <Button type="primary" @click="transferSubmit">确 定</Button>
    </span>
    </Modal>
  </div>
</template>
<script>
import CopyerSetting from '../approvalTask/approvalDetail/template/copyerSetting/coperSetting.vue';
import { mapState, mapActions, mapMutations } from 'vuex';
import listMixins from '@/mixins/listMixins';
import getPermissionMixin from '@/mixins/getPermissionMixin';
import { formItems, getColumns } from './config';
import authType from '@/config/authType';
import { transferActionOpApi } from '@/api/dataManager';
import { instApplyDetailApi } from '@/api/approvalTask';
import util from '@/assets/js/util';
export default {
  name: 'dataManage',
  mixins: [getPermissionMixin, listMixins],
  components: { CopyerSetting },
  data() {
    return {
      authType,
      formItems,
      filter: {
        pageIndex: 1,
        pageSize: 10,
        instStatus: ''
      },
      instApplyId: '', // 实例唯一标识
      dataConfig: { // 抄送类型
        userType: 1
      },
      transferModalFlag: false, // 转交弹窗
      columns: getColumns({
        // export: this.exportExcel, // 导出
        transfer: this.transfer, // 转交
        jumpApproval: this.jumpApproval // 跳转
      }),
      tempGroupModalVisible: false,
      isEdit: false,
      currentRowId: '',
      transferForm: { auditNote: '' }, // 转交表单
      transferValid: {} // 转交表单校验
    };
  },
  computed: {
    ...mapState('dataManage', ['totalCount', 'dataSource'])
  },
  methods: {
    ...mapActions('dataManage', ['getTableInfo', 'submitStatus']),
    ...mapMutations('dataManage', ['SET_DISABLED_ID']),
    // exportExcel(row) {
    //   this.$Modal.confirm({
    //     title: '导出',
    //     content: '确认导出？',
    //     onOk() {
    //       exportDataApi(row.id, '');
    //     }
    //   });
    // },
    // 转交
    transfer(row) {
      // 审批人和发起人是同一个人情况下---该流程审批、办理节点屏蔽该审批人
      if (row.allowApplyAuditSame === 0) {
        // 选择用户，设置禁止选择的id
        this.SET_DISABLED_ID(row.applyUserId);
      }

      this.instApplyId = row.id;
      this.transferModalFlag = true;
    },
    // 关闭转交弹窗
    handleVisible(visible) {
      // 清空-设置禁止选择用户的id
      if (!visible) {
        this.SET_DISABLED_ID('');
      }
    },
    // 转交弹窗确认
    transferSubmit (row) {
      const { person } = this.$refs.CopyerSetting.list;
      if (person && person instanceof Array && person.length == 1) {
        const transferUserId = person[0].id;
        const data = { transferUserId, instApplyId: this.instApplyId, ...this.transferForm };
        transferActionOpApi(data).then(res => {
          const { code, msg } = res.data;
          if (code == 200) {
            this.$Message.success(data.msg || '操作成功');
            this.transferModalFlag = false;
            this.getTableInfo({ filter: this.filter });
          }
        });
      } else {
        this.$Message.error('转交人员请选择一人');
      }
    },
    handlerSubmit() {
      this.$refs.tempGroupModal.submit().then(res => {
        if (res) {
          this.tempGroupModalVisible = false;
        }
      });
    },
    // 跳转
    jumpApproval(id) {
      instApplyDetailApi(id).then(res => {
        const { data, code } = res.data;
        if (code == 200) {
          const trendsForm = { formData: data.formCurrData, renderJson: data.formDesignDef };
          localStorage.setItem('trendsForm', JSON.stringify(trendsForm));
          this.$router.push({ path: '/approvalDetail', query: { instApplyId: id } });
        }
      });
    }
  }
};
</script>
<style lang="less"></style>
